<smart-card [backButton]="true" class="crud-create-wrapper" [offset]="5">
  <ng-template appPlaceholder></ng-template>
</smart-card>
